import React, { useId } from "react";
import { ObjectIcon } from "./ObjectIcon";
import { BoxIcon } from "lucide-react";
interface CardProps {
  title: React.ReactNode;
  icon?: BoxIcon;
  iconBg?: string;
  meta?: React.ReactNode;
  actions?: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
  bodyClassName?: string;
  children: React.ReactNode;
}
export function Card({
  title,
  icon,
  iconBg = '#0176D3',
  meta,
  actions,
  footer,
  className = '',
  bodyClassName = 'px-4 pb-4',
  children
}: CardProps) {
  const headingId = useId();
  return <section aria-labelledby={headingId} className={`rounded border border-sf-border bg-white shadow-card ${className}`} data-id="element-828" data-mp="5na139929od4">
      <header className="flex items-center gap-3 px-4 pb-2.5 pt-3" data-id="element-829" data-mp="n5hvbgrqfj7">
        {icon && <ObjectIcon icon={icon} bg={iconBg} data-id="element-830" data-mp="3sv5dkx2cd8ox" />}
        <div className="min-w-0 flex-1" data-id="element-831" data-mp="3nur2t79cvkn7">
          <h2 id={headingId} className="truncate text-sm font-bold text-sf-text" data-id="element-832" data-mp="3ntoglcmza6dm">
            {title}
          </h2>
          {meta && <p className="truncate text-xs text-sf-weak" data-id="element-833" data-mp="3ixh7xc376grz">{meta}</p>}
        </div>
        {actions && <div className="flex shrink-0 items-center gap-2" data-id="element-834" data-mp="1qcmr2210z1cc">{actions}</div>}
      </header>
      <div className={bodyClassName} data-id="element-835" data-mp="1v6r0crxrjlgl">{children}</div>
      {footer && <footer className="border-t border-sf-border px-4 py-2.5 text-[13px]" data-id="element-836" data-mp="1hf41ckcfryu4">{footer}</footer>}
    </section>;
}